import { TutorsState } from '@/store/tutors/types';

const state: TutorsState = {
  tutors: [],
  pager: {
    current: 1,
    last: 1,
    totalLength: 0,
  },
  sort: undefined,
};

export default state;
